import AuthService from "../../intranet/auth/auth_service";

export default class LocalService extends AuthService {
  constructor() {
    super("local");
  }

  changeStatus(id) {

    return this.execute("PUT", `/status/${id}`);

  }
}
